"use strict";

var ms = require('ms');

var DEFAULT_STATSIG_CONFIG = {
  initTimeoutMs: ms('3s'),
  rulesetsSyncIntervalMs: ms('10s')
}; // The hash option is required for the client sdk to properly consume the initialize response

var DEFAULT_STATSIG_INITIAL_VALUE_CONFIG = {
  hash: 'djb2'
};
var STATSIG_TYPES = {
  FEATURE_GATE: 'FEATURE_GATE',
  CONFIG: 'CONFIG',
  EXPERIMENT: 'EXPERIMENT'
};
var STATSIG_EVENTS = {
  EXPERIMENT_EVALUATION: 'experiment_evaluation'
};
module.exports = {
  STATSIG_TYPES: STATSIG_TYPES,
  DEFAULT_STATSIG_CONFIG: DEFAULT_STATSIG_CONFIG,
  DEFAULT_STATSIG_INITIAL_VALUE_CONFIG: DEFAULT_STATSIG_INITIAL_VALUE_CONFIG,
  STATSIG_EVENTS: STATSIG_EVENTS
};
